const galleryTitleMixin = {
    computed: {
        title() {
            try {
                return this.settings.title[this.$store.state.language] || this.settings.title.en;
            } catch(error) {
                captureException(error);
                console.error("Error getting title", error.message);
                return "Untitled";
            }
        },
    }
};

export default galleryTitleMixin;
